import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=53686300&scoped=true"
import script from "./order_info.vue?vue&type=script&lang=js"
export * from "./order_info.vue?vue&type=script&lang=js"
import style0 from "./order_info.vue?vue&type=style&index=0&id=53686300&prod&lang=less"
import style1 from "./order_info.vue?vue&type=style&index=1&id=53686300&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53686300",
  null
  
)

export default component.exports